import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as rate from '../rate'

const page = prebuilt.Page.get(prebuilt.Page.Id.RateReport)

export const RESOURCE = {
  payload: {
    alias: 'report',
    appAlias: rate.RESOURCE.payload.alias,
    description: page.description,
    name: 'Report',
    page: { id: prebuilt.Page.Id.RateReport },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
